<h2 class="popup-heading" mat-dialog-title>Screenshot Image</h2>
<mat-dialog-content class="mat-typography">
<div class="language-view">
    <img class="screenshot" src="{{ image }}" />
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="popup-save" mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
